// https://github.com/Dan503/time-input-polyfill/blob/08463f7823efd30a62f4d4755dd0bd2dd2b5ef04/core/static-values/sorted_number_keys.js
import allNumberKeys from './allNumberKeys'

const sortedNumberKeys: any = {}
// sorted_number_keys = { 48: 0, 49: 1, 96: 0, 97: 1, ... };
allNumberKeys.forEach((key: any, index: any) => {
  const numberVal = index > 9 ? index - 10 : index
  sortedNumberKeys[key] = numberVal
})

export default sortedNumberKeys
